import {connect} from 'react-redux';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import {updatePreferences} from '../actionCreators/preferences';
import actionCreators from '../actionCreators';
import CustomiseTestimonials from './CustomiseTestimonials';
import {deleteTestimonial, loadTestimonials, moveTestimonials, saveTestimonial,} from '../ducks/testimonials';


const mapStateToProps = (state) => {
  const reportType = state.reportType.value;
  const section = findSection(state.reportSections, reportType, 'TESTIMONIALS');
  const testimonials = state.testimonials[reportType];
  return {
    section,
    reportType,
    testimonials,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendEvent: (section, title) => {
      dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, title));
    },
    updateSectionValue: (value, dataKeyPath, reportType) => {
      dispatch(updateSectionValue({value, reportType, key: 'TESTIMONIALS', dataKeyPath: `sectionData.${dataKeyPath}`}));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    },
    removeTestimonial: (testimonial) => {
      dispatch(deleteTestimonial(testimonial));
    },
    saveTestimonial: (testimonial) => {
      dispatch(saveTestimonial(testimonial));
    },
    loadTestimonials: () => {
      dispatch(loadTestimonials());
    },
    sortTestimonials: (oldIndex, newIndex) => {
      dispatch(moveTestimonials(oldIndex, newIndex));
    }
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => {
      dispatchProps.updateSectionValue(value, dataKeyPath, stateProps.reportType);
      dispatchProps.sendEvent(stateProps.section, value);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseTestimonials);